import React from 'react';
import { Col, Row } from 'react-bootstrap';
import displayCurrency from '../../../../../helpers/displayCurrency';
import SummaryPremiumRow from '../SummaryPremiumRow/SummaryPremiumRow';
import PremiumBreakdown from '../../PremiumBreakdown/PremiumBreakdown';
import './SchemeSummary.scss';
import BenefitsModal from '../../BenefitsModal/BenefitsModal';
import SmartLuggagePremiumBreakdown from '../../SmartLuggagePremiumBreakdown/SmartLuggagePremiumBreakdown';
import {Divider} from "../../../../brochure/components/StyledComponents/StyledComponents";

const SchemeSummary = ({ selection, isMta, isSaving, isUpdating, isSmartLuggage }) => {
  if (isMta || isSaving || !selection) {
    return null;
  }
  const discount = (
    selection.premium_before_adjustments.gross - selection.premium.gross
  ).toFixed(2);

  return (
    <Col md={12} className={'bottom-bar'}>
      <Row>
        <Col md={12}>
          <h4 className={'chosen-scheme-header'}>Chosen Scheme{' '}</h4>
          <BenefitsModal scheme={selection.scheme} benefits={selection.benefits} />
        </Col>
      </Row>
      <div className={'scheme-summary'}>
        <Row>
          <Col md={12}>{selection.scheme.name} &nbsp;</Col>
        </Row>

        <SummaryPremiumRow
          label={'Base Premium'}
          isUpdating={isUpdating}
          value={displayCurrency(selection.premium.principal)}
        />

        <SummaryPremiumRow
          label={`IPT (${selection.rates.tax_rate || 0}%)`}
          isUpdating={isUpdating}
          value={displayCurrency(selection.premium.tax)}
        />

        <SummaryPremiumRow
          label={'Admin Fees'}
          isUpdating={isUpdating}
          value={displayCurrency(selection.premium.ex_tax)}
        />

        {isSmartLuggage ? (
          <SummaryPremiumRow
            label={'Total Payable'}
            isUpdating={isUpdating}
            value={
              <SmartLuggagePremiumBreakdown
                premium={selection}
                className="small-premium"
              />
            }
          />
        ) : (
          <SummaryPremiumRow
            label={'Total Payable'}
            isUpdating={isUpdating}
            value={<PremiumBreakdown premium={selection} className="small-premium" />}
          />
        )}

        <SummaryPremiumRow
          label={'Discount'}
          isUpdating={isUpdating}
          value={discount ? `(${discount})` : null}
        />
      </div>
      <div className={'small-divider'} />
    </Col>
  );
};

export default SchemeSummary;
